import React, { useEffect, useState } from 'react';
import { getData, postData } from '../store/utils';
import { FaDownload } from 'react-icons/fa';
import { HiRefresh } from "react-icons/hi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { getData, postData } from '../store/utils';
import Swal from "sweetalert2";
import Loader from '../component/Loader';
import { formatDate } from '../component/common';
import { format } from 'date-fns';
import Select from "react-select";
import { useDebounce } from "use-debounce";


const AccountStatement = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [data, setData] = useState(null);
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const [merchantUserData, setMerchantUserData] = useState([]);
    const [userId, setUserId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [inputValue, setInputValue] = useState(""); // track live input
    const [debouncedSearchTerm] = useDebounce(searchTerm, 500);



    const handleFromDateChange = (date) => {
        const formattedDate = date ? format(date, "yyyy-MM-dd") : null;
        setFromDate(formattedDate);
    };

    const handleToDateChange = (date) => {
        const formattedDate = date ? format(date, "yyyy-MM-dd") : null;
        setToDate(formattedDate);
    };

    console.log("date++++", fromDate, toDate)

    const fetchData = async () => {
        try {
            if (!userId) {
                Swal.fire({
                    icon: "warning",
                    title: "Missing Fields!",
                    text: "Please select the User before downloading.",
                });
                return;
            }

            const sendTempData = {
                fromDate,
                toDate,
                userId,
            };

            setIsLoadingOn(true);
            const response = await postData(`documents/createLedger`, sendTempData);
            setIsLoadingOn(false);

            if (response.statusCode === 200) {
                if (response?.data?.ledgerPath) {
                    const link = document.createElement("a");
                    link.href = response.data.ledgerPath;
                    link.download = "data.csv";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    Swal.fire({
                        icon: "success",
                        title: "Success!",
                        text: "File downloaded successfully!",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error!",
                        text: response.message || "Something went wrong.",
                    });
                }
            } else {
                Swal.fire({
                    icon: "error",
                    text: response?.data?.errors?.msg || "Something went wrong",
                });
            }
        } catch (error) {
            setIsLoadingOn(false);
            console.error("Error fetching data:", error);
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Something went wrong while fetching data.",
            });
        }
    };




    const getMerchantData = async (search = "", page = 0, pageSize = 50, sortBy = "", orderBy = "") => {
        setIsLoadingOn(true);
        const apiUrl = `users/getMerchants/1?page=${page + 1}&pageSize=${pageSize}&shopName=${search}`;

        if (sortBy && orderBy) {
            apiUrl += `&sortBy=${sortBy}&orderBy=${orderBy}`;
        }

        const tempData = await postData(apiUrl);
        setIsLoadingOn(false);
        if (tempData.statusCode === 200) {
            const options = tempData.data.records.map((item) => ({
                label: `${item.shopName} (${item.name})`,
                value: item.userId,
            }));
            setMerchantUserData(options);
        }
    };

    useEffect(() => {
        getMerchantData(debouncedSearchTerm);
    }, [debouncedSearchTerm]);

    // Initial load
    useEffect(() => {
        getMerchantData();
    }, []);

    // Function to update search input
    const handleSearchInputChange = (value, { action }) => {
        if (action === "input-change") {
            setInputValue(value);        // update visible input
            setSearchTerm(value);        // update search term for debounce
        }
    };


    return (
        <>
            {isLoadingOn ? <Loader /> : ''}
            <h3 className='tableHeaderMsg'>Account Statement</h3>
            <div className='customHeaderTable distable'>
                <div className="container-fluid">
                    <div className="row alignmentTable">
                        {/* <h6><strong>Invoice Date :</strong></h6> */}
                        <div className="col-md-2">
                            <label>From :</label><br />
                            <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selected={fromDate ? new Date(fromDate) : null}
                                onChange={handleFromDateChange}
                                placeholderText="Select Start Date"
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="col-md-2">
                            <label>To :</label><br />
                            <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selected={toDate ? new Date(toDate) : null}
                                onChange={handleToDateChange}
                                placeholderText="Select End Date"
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="col-md-4">
                            <label>User Id :</label><br />
                            <Select
                                placeholder="User Shop Name"
                                name="userId"
                                options={merchantUserData}
                                inputValue={inputValue}                  // controlled input
                                isLoading={isLoadingOn}
                                isClearable
                                onInputChange={handleSearchInputChange}  // dynamic search
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        const userId = selectedOption.value;
                                        console.log("userId++++", userId);
                                        setUserId(userId);
                                    } else {
                                        setUserId(null);
                                    }
                                }}
                            />


                        </div>
                        <div className="col-md-2 text-center">
                            <button className='searchTableData' onClick={fetchData}><FaDownload /> Download</button>
                        </div>
                        <div className="col-md-2 text-center">
                            <button className='resetTableData' onClick={() => { setFromDate(null); setToDate(null); }}><HiRefresh /> Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* {isLoadingOn ? <Loader /> : null} */}
            {/* Display your table or other components here */}
        </>
    );
};

export default AccountStatement;
